import { useEffect, useState } from "react";
import { toast } from "sonner";
import { api, errMsg } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { PeopleList } from "@/components/admin/PeopleTab";

export const PasswordCard = () => {
  const { user } = useAuth();
  const [f, setF] = useState({ current: "", next: "", confirm: "" });
  const [error, setError] = useState("");
  const [busy, setBusy] = useState(false);
  const [note, setNote] = useState("");
  const set = (k) => (e) => setF({ ...f, [k]: e.target.value });
  const submit = async (e) => {
    e.preventDefault();
    setError("");
    if (f.next.length < 8) return setError("Use at least 8 characters.");
    if (f.next !== f.confirm) return setError("The two new passwords don't match.");
    setBusy(true);
    try {
      await api.post("/auth/change-password", { current_password: f.current, new_password: f.next });
      setF({ current: "", next: "", confirm: "" });
      toast.success("Password changed. Other devices were signed out.");
    } catch (err) { setError(errMsg(err)); } finally { setBusy(false); }
  };
  const setLink = async () => {
    try { setNote((await api.post("/auth/set-password-link")).data.message); } catch (err) { setError(errMsg(err)); }
  };
  return (
    <section className="settings-card" data-testid="password-card">
      <h2 className="text-base font-semibold text-neutral-900">Password</h2>
      {user?.has_password ? (
        <form className="mt-4 max-w-sm" onSubmit={submit} data-testid="change-password-form">
          <input className="login-input" type="password" placeholder="Current password" autoComplete="current-password" required value={f.current} onChange={set("current")} data-testid="current-password-input" />
          <input className="login-input" type="password" placeholder="New password" autoComplete="new-password" required value={f.next} onChange={set("next")} data-testid="new-password-input" />
          <input className="login-input" type="password" placeholder="Confirm new password" autoComplete="new-password" required value={f.confirm} onChange={set("confirm")} data-testid="confirm-password-input" />
          <p className="text-xs text-neutral-500 mb-3">At least 8 characters, not your email, and different from your current password.</p>
          {error && <p className="text-sm text-red-600 mb-3" data-testid="change-password-error">{error}</p>}
          <button className="btn-ink !px-6" disabled={busy} data-testid="change-password-submit">{busy ? "Saving…" : "Change password"}</button>
        </form>
      ) : (
        <div className="mt-3" data-testid="google-only-password">
          <p className="text-sm text-neutral-600">You sign in with Google.</p>
          {note ? <p className="text-sm text-neutral-800 mt-3" data-testid="set-password-note">{note}</p>
            : <button className="btn-outline mt-3 !py-1.5 !px-4 text-sm" onClick={setLink} data-testid="set-password-button">Set a password</button>}
          {error && <p className="text-sm text-red-600 mt-3" data-testid="change-password-error">{error}</p>}
        </div>
      )}
    </section>
  );
};

export const PeopleCard = () => {
  const [people, setPeople] = useState(null);
  useEffect(() => { api.get("/people").then((r) => setPeople(r.data.people)).catch(() => setPeople([])); }, []);
  if (!people) return null;
  return (
    <section className="settings-card" data-testid="people-card">
      <h2 className="text-base font-semibold text-neutral-900">People</h2>
      <p className="text-sm text-neutral-500 mb-3">Birthdays used for Birthday Books. Only admins can change this list.</p>
      <PeopleList people={people} />
    </section>
  );
};
